import { useTranslation } from 'react-i18next'
import { ApplicationForm } from './ApplicationForm'

interface Props {
  title?: string
  subtitle?: string
  showContact?: boolean
  noBg?: boolean
  /** Fixed direction name (e.g. current DirectionPage title). When set, the form's direction selector is hidden. */
  direction?: string
}

export function ContactFormSection({
  title,
  subtitle,
  showContact = false,
  noBg = false,
  direction,
}: Props) {
  const { t } = useTranslation()
  const finalTitle = title ?? t('contactForm.defaultTitle')
  const finalSubtitle = subtitle ?? t('contactForm.defaultSubtitle')
  return (
    <section
      className={noBg ? undefined : 'section-hero-bg'}
      style={noBg ? { padding: '140px 0' } : { padding: '140px 0', backgroundSize: 'auto 100%' }}
    >
      <div className="container-page grid-content" style={{ gap: 36 }}>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <h2 style={{ margin: 0, fontSize: 36, fontWeight: 700, letterSpacing: '-.015em', color: '#FFFFFF', lineHeight: 1.15 }}>{finalTitle}</h2>
          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.65, color: '#93A3AE', maxWidth: 440 }}>{finalSubtitle}</p>
          {showContact && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
              <a href="tel:+70000000000" style={{ color: '#FFFFFF', fontSize: 18, fontWeight: 600 }}>+7 (XXX) XXX-XX-XX</a>
              <a href="mailto:mail@titan-top.ru" style={{ color: '#93A3AE', fontSize: 14 }}>mail@titan-top.ru</a>
            </div>
          )}
        </div>

        <ApplicationForm direction={direction} />
      </div>
    </section>
  )
}
